import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { useEffect } from "react"
import { COMMAND_PRIORITY_EDITOR, createCommand, type LexicalCommand } from "lexical"
import { $insertNodes } from "lexical"
import type { ImagePayload } from '../nodes/ImageNode';
import {$createImageNode} from '../nodes/ImageNode';
import { useEditorMeta } from "../hooks/useMeta";

export const INSERT_IMAGE_COMMAND: LexicalCommand<ImagePayload> = createCommand("INSERT_IMAGE_COMMAND")

export function ImagePlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext()
   const { productId, locale } = useEditorMeta();

  useEffect(() => {
    return editor.registerCommand<ImagePayload>(
      INSERT_IMAGE_COMMAND,
      (payload) => {
        const imageNode = $createImageNode({
          ...payload,
          productId: productId,
          locale: locale,
        })
        $insertNodes([imageNode])
        return true
      },
      COMMAND_PRIORITY_EDITOR,
    )
  }, [editor, productId, locale])

  return <></>
}